(function () {
  'use strict';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Animaciones de entrada */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.pk-reveal:not(.pk-visible)');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('pk-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('pk-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Cuenta atrás */
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function getEnd(el) {
    var mode = el.getAttribute('data-mode') || 'fecha';
    if (mode === 'diario') { var end = new Date(); end.setHours(23, 59, 59, 999); return end; }
    var raw = (el.getAttribute('data-end') || '').trim().replace(' ', 'T');
    if (!raw) return null;
    if (raw.length === 10) raw += 'T23:59:59';
    var d = new Date(raw);
    return isNaN(d.getTime()) ? null : d;
  }
  function initCountdowns(root) {
    (root || document).querySelectorAll('[data-pk-countdown]:not([data-pk-ready])').forEach(function (el) {
      el.setAttribute('data-pk-ready', '');
      var end = getEnd(el);
      if (!end) { el.classList.add('is-over'); return; }
      var dEl = el.querySelectorAll('[data-d]'), hEl = el.querySelectorAll('[data-h]'),
          mEl = el.querySelectorAll('[data-m]'), sEl = el.querySelectorAll('[data-s]'),
          dWrap = el.querySelectorAll('[data-d-wrap]');
      function set(list, v) { list.forEach(function (n) { n.textContent = v; }); }
      var timer;
      function tick() {
        var diff = end.getTime() - Date.now();
        if (diff <= 0) { el.classList.add('is-over'); clearInterval(timer); return; }
        var s = Math.floor(diff / 1000);
        var d = Math.floor(s / 86400); s -= d * 86400;
        var h = Math.floor(s / 3600); s -= h * 3600;
        var m = Math.floor(s / 60); s -= m * 60;
        set(dEl, d); set(hEl, pad(h)); set(mEl, pad(m)); set(sEl, pad(s));
        dWrap.forEach(function (n) { n.style.display = d > 0 ? '' : 'none'; });
      }
      timer = setInterval(tick, 1000);
      tick();
    });
  }

  /* Dinero */
  function formatMoney(cents, format) {
    format = format || '${{amount}}';
    cents = Math.round(cents);
    function fmt(n, dec, th, ds) {
      var parts = (n / 100).toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts[0] + (parts[1] ? ds + parts[1] : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        default: return fmt(cents, 2, ',', '.');
      }
    });
  }

  /* Carrito */
  function addToCart(items) {
    var drawer = document.querySelector('cart-drawer');
    var sections = [];
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
    }
    var body = { items: items };
    if (sections.length) { body.sections = sections.join(','); body.sections_url = window.location.pathname; }
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    return fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok || res.json.status) throw new Error(res.json.description || res.json.message || 'Error');
        if (drawer && sections.length && res.json.sections) {
          if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
          drawer.renderContents(res.json);
        } else {
          window.location.href = cartUrl;
        }
        return res.json;
      });
  }

  /* Página de producto */
  function initProduct(root) {
    (root || document).querySelectorAll('[data-pk-product]:not([data-pk-ready])').forEach(function (wrap) {
      wrap.setAttribute('data-pk-ready', '');
      var dataEl = wrap.querySelector('[data-pk-variants]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var moneyFormat = wrap.getAttribute('data-money-format');
      var current = variants.filter(function (v) { return v.id == wrap.getAttribute('data-selected'); })[0] || variants[0];
      var selected = current.options.slice();
      var qty = 1;
      var mainImg = wrap.querySelector('[data-pk-main-img]');
      var thumbs = wrap.querySelectorAll('[data-pk-thumb]');
      var atc = wrap.querySelector('[data-pk-atc]');
      var atcLabel = wrap.querySelector('[data-pk-atc-label]');
      var msg = wrap.querySelector('[data-pk-msg]');
      var slotsBox = wrap.querySelector('[data-pk-slots]');
      var slots = wrap.querySelectorAll('[data-pk-slot]');
      var bundleOpts = wrap.querySelectorAll('[data-pk-bundle]');
      var sticky = document.querySelector('[data-pk-sticky="' + wrap.getAttribute('data-section') + '"]');
      var form = wrap.querySelector('form.pk-atc-form');
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      try {
        var packParam = parseInt(new URLSearchParams(window.location.search).get('pack'), 10);
        if (packParam && wrap.querySelector('[data-pk-bundle][data-qty="' + packParam + '"]')) qty = packParam;
      } catch (err) {}

      function findVariant(opts) {
        return variants.filter(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        })[0];
      }
      function setMain(src, mediaId) {
        if (!mainImg || !src) return;
        mainImg.src = src;
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-media') == mediaId); });
        var active = wrap.querySelector('[data-pk-thumb].is-active');
        if (active) {
          var parent = active.parentElement;
          parent.scrollTo({ left: active.offsetLeft - parent.clientWidth / 2 + active.clientWidth / 2, behavior: reduceMotion ? 'auto' : 'smooth' });
        }
      }
      function priceFor(n) {
        var opt = wrap.querySelector('[data-pk-bundle][data-qty="' + n + '"]');
        var disc = opt ? parseFloat(opt.getAttribute('data-discount') || '0') : 0;
        return { now: current.price * n * (1 - disc / 100), was: (current.compare && current.compare > current.price ? current.compare : current.price) * n };
      }
      function render() {
        current = findVariant(selected) || current;
        wrap.querySelectorAll('[data-pk-opt]').forEach(function (btn) {
          var on = btn.getAttribute('data-value') === selected[+btn.getAttribute('data-index')];
          btn.classList.toggle('is-active', on);
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        wrap.querySelectorAll('[data-pk-opt-current]').forEach(function (el) {
          el.textContent = selected[+el.getAttribute('data-index')] || '';
        });
        var hasCompare = current.compare && current.compare > current.price;
        wrap.querySelectorAll('[data-pk-price]').forEach(function (el) { el.textContent = formatMoney(current.price, moneyFormat); });
        wrap.querySelectorAll('[data-pk-compare]').forEach(function (el) { el.textContent = hasCompare ? formatMoney(current.compare, moneyFormat) : ''; el.style.display = hasCompare ? '' : 'none'; });
        wrap.querySelectorAll('[data-pk-save]').forEach(function (el) {
          el.style.display = hasCompare ? '' : 'none';
          el.textContent = hasCompare ? el.getAttribute('data-template').replace('[ahorro]', formatMoney(current.compare - current.price, moneyFormat)) : '';
        });
        wrap.querySelectorAll('[data-pk-percent]').forEach(function (el) {
          el.style.display = hasCompare ? '' : 'none';
          if (hasCompare) el.textContent = '-' + Math.round((1 - current.price / current.compare) * 100) + '%';
        });
        bundleOpts.forEach(function (opt) {
          var n = +opt.getAttribute('data-qty');
          var p = priceFor(n);
          var now = opt.querySelector('[data-pk-bundle-now]'), was = opt.querySelector('[data-pk-bundle-was]');
          if (now) now.textContent = formatMoney(p.now, moneyFormat);
          if (was) was.textContent = p.was > p.now ? formatMoney(p.was, moneyFormat) : '';
          opt.classList.toggle('is-active', n === qty);
          var input = opt.querySelector('input'); if (input) input.checked = n === qty;
        });
        if (slotsBox) {
          slotsBox.hidden = qty < 2;
          slots.forEach(function (slot, i) {
            slot.hidden = i >= qty - 1;
            var sel = slot.querySelector('select'), img = slot.querySelector('img');
            var opts = selected.slice(); opts[0] = sel.value;
            var v = findVariant(opts);
            if (img && v && v.img) img.src = v.img;
          });
        }
        if (current.img) setMain(current.img, current.media);
        if (idInput) idInput.value = current.id;
        if (atc) {
          atc.disabled = !current.available;
          if (atcLabel) {
            atcLabel.textContent = current.available
              ? atc.getAttribute('data-label').replace('[precio]', formatMoney(priceFor(qty).now, moneyFormat))
              : atc.getAttribute('data-soldout');
          }
        }
        if (sticky) {
          var sImg = sticky.querySelector('img'); if (sImg && current.img) sImg.src = current.img;
          var sName = sticky.querySelector('[data-pk-sticky-name]'); if (sName) sName.textContent = selected.join(' · ');
          var sPrice = sticky.querySelector('[data-pk-sticky-price]'); if (sPrice) sPrice.textContent = formatMoney(priceFor(qty).now, moneyFormat);
        }
        if (wrap.getAttribute('data-update-url') === 'true' && window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', current.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      wrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-pk-opt]');
        if (btn && wrap.contains(btn)) {
          e.preventDefault();
          selected[+btn.getAttribute('data-index')] = btn.getAttribute('data-value');
          render();
          return;
        }
        var th = e.target.closest('[data-pk-thumb]');
        if (th && wrap.contains(th)) {
          e.preventDefault();
          var designVal = th.getAttribute('data-design');
          if (designVal) { selected[0] = designVal; render(); }
          else setMain(th.getAttribute('data-src'), th.getAttribute('data-media'));
        }
      });
      bundleOpts.forEach(function (opt) {
        opt.addEventListener('click', function () { qty = +opt.getAttribute('data-qty'); render(); });
      });
      slots.forEach(function (slot) {
        var sel = slot.querySelector('select');
        if (sel) sel.addEventListener('change', render);
      });

      if (atc && form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (atc.disabled) return;
          var items = [{ id: current.id, quantity: 1 }];
          slots.forEach(function (slot, i) {
            if (i >= qty - 1) return;
            var opts = selected.slice(); opts[0] = slot.querySelector('select').value;
            var v = findVariant(opts);
            if (!v) return;
            var existing = items.filter(function (it) { return it.id === v.id; })[0];
            if (existing) existing.quantity += 1; else items.push({ id: v.id, quantity: 1 });
          });
          if (msg) msg.textContent = '';
          atc.classList.add('is-loading');
          atc.disabled = true;
          addToCart(items).catch(function (err) {
            if (msg) msg.textContent = err.message;
          }).then(function () {
            atc.classList.remove('is-loading');
            atc.disabled = !current.available;
          });
        });
      }

      if (sticky && atc && form && 'IntersectionObserver' in window) {
        var sBtn = sticky.querySelector('[data-pk-sticky-btn]');
        if (sBtn) sBtn.addEventListener('click', function (e) {
          e.preventDefault();
          if (form.requestSubmit) form.requestSubmit(); else atc.click();
        });
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
          });
        }).observe(atc);
      }

      render();
    });
  }

  function initAll(root) { initReveal(root); initCountdowns(root); initProduct(root); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();